<template>
    <InputText
        type="number"
        :modelValue="value"
        @blur="$emit('handleValueChange', parseFloat($event.target.value))"
        @wheel="$event.target.blur()"
        placeholder="Enter number"
    />
</template>

<script>
export default {
    name: 'FloatRule',
    props: ['value'],
};
</script>

<style scoped></style>
